// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ACCESS_TOKEN: "UCAToken",
  REFRESH_TOKEN: "UCARefreshToken",
};
